<template>
  <ChartBase title="Daily Orders (Last 30 Days)" :loading="loading">
    <BarChart
      class="chart-thirty-day-new-vs-returning line-chart"
      :chart-options="chartOptions"
      :chart-data="chartData"
    />
  </ChartBase>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { BarChartOptions } from '@/constants/ChartOptions'
import { CHART_COLORS } from '@/constants/ChartOptions'
import ChartBase from '@/components/ChartBase.vue'

import _min from 'lodash/min'
import _max from 'lodash/max'
import { Bar as BarChart } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
export default {
  name: 'ChartThirtyDayNewVsReturning',
  components: {
    ChartBase,
    BarChart,
  },
  data() {
    return {
      loading: true,
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: BarChartOptions,
    }
  },
  computed: {
    ...mapGetters('shop', ['getShopId']),
  },
  async mounted() {
    const {
      data: chartData,
    } = await this.getChartThirtyDayNewVsReturningCustomers()
    this.chartData.labels = chartData.labels
    this.chartData.datasets = chartData.datasets
    this.chartData.datasets[0].borderColor = CHART_COLORS.red
    this.chartData.datasets[0].backgroundColor = CHART_COLORS.red
    this.chartData.datasets[1].borderColor = CHART_COLORS.blue
    this.chartData.datasets[1].backgroundColor = CHART_COLORS.blue

    // await this.setChartStepSize(chartData.datasets[0].data)
    // await this.setTotalSales(chartData.datasets[0].data)
    this.loading = false
  },
  methods: {
    ...mapActions('shop', ['getChartThirtyDayNewVsReturningCustomers']),

    setChartStepSize(chartDataSet) {
      let min = _min(chartDataSet)
      let headroom = 1.15
      let max = _max(chartDataSet) * headroom

      this.chartOptions.scales.y.suggestedMax = max
      let approxStepSize = (max - min) / 3
      let roundToNearest = 20
      this.chartOptions.scales.y.ticks.stepSize =
        Math.ceil(approxStepSize / roundToNearest) * roundToNearest
    }, // setChartStepSize
  },
}
</script>

<style scoped>
.line-chart {
  height: 200px;
}
</style>
